<template>
    <div>
        <div v-if="showType === 0" class="dialog-description">
            <table>
                <tr>
                    <td colspan="2">
                        {{ $t("message.title_import_review_required") }}
                    </td>
                </tr>
                <tr>
                    <td v-t="'message.item_importType'"></td>
                    <td style="padding-left:20px">{{ getImportType(returnInfo.importType) }}</td>
                </tr>
                <tr>
                    <td v-t="'message.item_fileName'"></td>
                    <td style="padding-left:20px">{{ returnInfo.csvFileName }}</td>
                </tr>
                <tr v-if="(csvErrorLineCount > 0 || csvUnprocessedLineCount > 0)">
                    <td v-t="'message.item_csv_import_result_summary'" style="vertical-align: top;"></td>
                    <td style="padding-left:20px">
                        <div v-if="csvUnprocessedLineCount > 0">
                            {{ $t("message.info_csv_import_result_with_unprocessed", {
                            success: csvSuccessLineCount,
                            error: csvErrorLineCount,
                            total: csvTotalLineCount,
                            unprocessed: csvUnprocessedLineCount,
                        }) }}
                        </div>
                        <div v-else-if="csvErrorLineCount > 0">{{ $t("message.info_csv_import_result", {
                            success: csvSuccessLineCount,
                            error: csvErrorLineCount,
                            total: csvTotalLineCount
                        }) }}
                        </div>
                        <div v-if="returnInfo.errorUserInputs?.length > 0">
                            <button @click="() => $emit('errorDataRequest')" type="button" class="transparent-button">
                                <span class="transparent-button__text">[ {{ $t("message.title_csv_download_error_rows")
                                    }} ]</span>
                            </button>
                        </div>
                        <div v-if="returnInfo.unprocessedUserInputs?.length > 0">
                            <button @click="() => $emit('unprocessedDataRequest')" type="button"
                                    class="transparent-button">
                                <span
                                    class="transparent-button__text">
                                    [ {{ $t("message.title_csv_download_unprocessed_rows") }} ]</span>
                            </button>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" v-t="'message.desc_import_errorInfo_note'"></td>
                </tr>
            </table>
        </div>
        <div v-else class="dialog-description" v-html="$t('message.desc_import_errorInfo')"/>
        <br>
        <table width="100%" v-if="returnInfo.errorLineInfo.length > 0">
            <thead>
            <tr class="error-record-title">
                <td class="error-record-number" v-t="'message.item_line_number'"></td>
                <td class="error-record-detail" v-t="'message.item_error_information'"></td>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="(errorLine,lineindex) in returnInfo.errorLineInfo"
                :class="{ 'error-record': ((lineindex % 2) === 0) , 'error-record-thick': ((lineindex % 2) !== 0) }"
            >
                <td class="error-record-number"> {{ errorLine.lineNo }}</td>
                <td class="error-record-detail">
                        <span v-for="(errorCode , index) in errorLine.errorCodeList">
                            <span v-if="errorCodeIsInvalidUtf8(errorCode)">
                                {{ getErrorDescription(errorCode) }}<br>
                                {{ getGuidanceOfInvalidUtf8() }}
                            </span>
                            <span v-else-if="index === 0">
                                {{ getErrorDescription(errorCode) }}
                            </span>
                            <span v-else>
                                &nbsp;|&nbsp; {{ getErrorDescription(errorCode) }}
                            </span>
                        </span>
                    <span v-if="errorLine.errorParamList.length > 0">
                            <span v-if="errorLine.errorCodeList.length > 1">&nbsp;|&nbsp;</span>
                            (
                            <span v-for="(errorParam , index) in errorLine.errorParamList">
                                <span v-if="index === 0">
                                    {{ errorParam }}
                                </span>
                                <span v-else>
                                    &nbsp;,&nbsp; {{ errorParam }}
                                </span>
                            </span>
                            )
                        </span>
                </td>
            </tr>
            </tbody>
        </table>
        <div v-else class="no-errors-result">
            <img :src="require('@/assets/icon_check_green.svg')" alt="icon for no errors"
                 class="no-errors-result__icon"/>
            <span>{{ $t("message.desc_no_errors") }}</span>
        </div>
    </div>
</template>

<script>
import constants from './constants.js';
import commonUtil from './commonutil.js';

export default {
    emits: ["errorDataRequest", "unprocessedDataRequest"],
    methods: {
        getErrorDescription(errorCode) {
            return commonUtil.getCsvErrorDescription(this.$i18n, errorCode);
        },
        getImportType(importType) {
            switch (importType) {
                case constants.CSV_USER:
                    return commonUtil.getMessageText(this.$i18n, "item_user");
                case constants.CSV_GROUP:
                    return commonUtil.getMessageText(this.$i18n, "item_group");
                case constants.CSV_USER_GROUP:
                    return commonUtil.getMessageText(this.$i18n, "title_userGroup");
                case constants.CSV_BELL:
                    return commonUtil.getMessageText(this.$i18n, "item_bell");
                case constants.CSV_BELL_AUTH_USER:
                    return commonUtil.getMessageText(this.$i18n, "item_bell_auth_user");
            }
        },
        errorCodeIsInvalidUtf8(errorCode) {
            return errorCode === constants.STATUS_ERROR_INVALID_UTF8;
        },
        getGuidanceOfInvalidUtf8() {
            return commonUtil.getMessageText(this.$i18n, "error_csv_invalid_utf8_guidance");
        },
    },
    props: {
        returnInfo: {
            type: Object,
        },
        showType: {
            type: Number,
        },
        csvUnprocessedLineCount: {
            type: Number,
            default: 0,
        },
        csvSuccessLineCount: {
            type: Number,
            default: 0,
        },
        csvErrorLineCount: {
            type: Number,
            default: 0,
        },
        csvTotalLineCount: {
            type: Number,
            default: 0,
        },
    },
}
</script>

<style scoped>
tbody {
    display: block;
    height: 460px;
    overflow-y: scroll;
}

thead, tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
}

.error-record-title {
    width: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
    display: block;
    background-color: #f6f6f6
}

.error-record {
    width: 100%;
    border-bottom: 1px #eee solid;
    padding-top: 10px;
    padding-bottom: 10px;
    display: block;
}

.error-record-thick {
    width: 100%;
    border-bottom: 1px #eee solid;
    padding-top: 10px;
    padding-bottom: 10px;
    display: block;
    background-color: #fafafa;
}

.error-record-number {
    width: 80px;
    padding-left: 10px;
}

.error-record-detail {
    padding-left: 10px;
}

.dialog-description {
    padding-top: 16px;
    display: block;
}

.transparent-button {
    padding: 0;
    white-space: nowrap;
    color: #5171cb;

    .transparent-button__text {
        vertical-align: middle;
    }
}

.no-errors-result {
    display: flex;
    align-items: center;
    column-gap: 8px;

    .no-errors-result__icon {
        width: 1rem;
        height: 1rem;
    }
}

</style>
